"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var _preventScroll = false;

var RoutingService = /*#__PURE__*/function () {
  function RoutingService() {
    _classCallCheck(this, RoutingService);
  }

  _createClass(RoutingService, null, [{
    key: "preventScroll",
    value: function preventScroll() {
      if (this.preventScrollTimeout) {
        try {
          clearTimeout(this.preventScrollTimeout);
        } catch (e) {}
      }

      _preventScroll = true;
      this.preventScrollTimeout = setTimeout(function () {
        _preventScroll = false;
      }, 500);
    }
  }, {
    key: "toTop",
    value: function toTop() {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 10);
    }
  }, {
    key: "isScrollPrevented",
    value: function isScrollPrevented() {
      return _preventScroll;
    }
  }]);

  return RoutingService;
}();

exports["default"] = RoutingService;

_defineProperty(RoutingService, "preventScrollTimeout", void 0);